var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-agreement"},[_c('v-title',{attrs:{"value":_vm.name}}),_c('PageLoading',{attrs:{"onFetch":_vm.onFetch}}),_c('div',{domProps:{"innerHTML":_vm._s(_vm.content.agreementContents)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }